<!--  -->
<template>
  <div class="total">
    <img style="width: 100%" src="@/../static/img/title4.jpg" alt="" />
    <div style="margin: 60px 0">
      <h3 class="content-title">关于我们</h3>
      <div>ABOUT US</div>
    </div>
    <div class="introduce">
      <div class="introduceImg-box">
        <!-- <img
          class="introduce-img"
          style=""
          src="@/../static/img/aboutTitle.png"
          alt=""
        /> -->
        <vue-flux
          class="introduce-img"
          :options="vfOptions"
          :images="vfImages"
          :transitions="vfTransitions"
          ref="slider"
        >
          <template v-slot:caption>
            <flux-caption />
          </template>
        </vue-flux>
      </div>
      <div class="introduce-text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们是一家致力于“互联网+医疗健康”的科技型企业，广州呼吸健康研究院的何建行院长是我们的医疗技术总顾问，我们依托广医、浙大、中南大学等院校的人才和技术，以一批国际、国内知名的医学、图像识别和计算机科学家，领衔建设疾病联防联控平台，自主研发数据无损压缩、GPU图像渲染、云平台大数据归档管理与快速检索、区块链加密等技术，实现区域内影像数据的互联互通互认。公司成立以来，为服务我国的疾病预防和控制工作尽一份绵薄之力，得到上级领导的充分肯定和社会各界的高度评价。
      </div>
    </div>
    <div style="margin: 80px 0">
      <h3 class="content-title">专利资质</h3>
      <div>PATENT QUALIFICATION</div>
    </div>
    <div class="title">
      <!-- <span class="demonstration">默认 Hover 指示器触发</span> -->
      <el-carousel height="5.5rem" indicator-position="outside">
        <el-carousel-item v-for="(item, index) in title" :key="item.url">
          <div class="qualifications">
            <img
              :class="index != 5 ? 'qualifications-img' : 'qualifications-img2'"
              v-for="item2 in item"
              :key="item2.url"
              :src="item2.url"
              alt=""
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader,
} from "vue-flux";
export default {
  name: "home",
  components: {
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader,
  },
  data() {
    return {
      vfOptions: {
        autoplay: true,
      },
      vfImages: [
        "/static/img/aboutTitle.png",
        "/static/img/aboutTitle1.png",
      ],
      //   vfImages1: [
      //     "@/../static/img/region/1.png",
      //     "@/../static/img/region/2.png",
      //     "@/../static/img/region/3.png",
      //   ],
      //   vfImages2: [
      //     "@/../static/img/MedicalAssociation/1.png",
      //     "@/../static/img/MedicalAssociation/2.png",
      //     "@/../static/img/MedicalAssociation/3.png",
      //   ],
      vfTransitions: ["zip"],
      title: [],
    };
  },

  mounted() {
    this.produceTitle();
  },

  methods: {
    produceTitle() {
      for (let index = 0; index < 5; index++) {
        this.title.push([
          {
            url: "/static/img/qualifications/" + (index * 10 + 1) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 2) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 3) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 4) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 5) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 6) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 7) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 8) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 9) + ".jpg",
          },
          {
            url: "/static/img/qualifications/" + (index * 10 + 10) + ".jpg",
          },
        ]);
      }
      // this.title.push([
      //   {
      //     url: "@/../static/img/资质/8 (1)" + ".jpg",
      //   },
      //   {
      //     url: "@/../static/img/资质/8 (2)" + ".jpg",
      //   },
      //   {
      //     url: "@/../static/img/资质/8 (3)" + ".jpg",
      //   },
      //   {
      //     url: "@/../static/img/资质/8 (4)" + ".jpg",
      //   },
      // ]);
      // console.log(this.title);
    },
  },
};
</script>
<style lang='less' scoped>
.total {
  width: 100%;
  height: 100%;
  margin-bottom: 80px;
}
.qualifications {
  display: flex;
  flex-wrap: wrap;
  width: 10rem;
  margin: 0 auto;
  .qualifications-img {
    width: 1.8rem;
    height: 2.5rem;
    // margin: 5px 0.15rem;
    margin: 5px auto;
  }
  .qualifications-img2 {
    width: 4.5rem;
    margin: 10px auto;
  }
}
.content-title {
  color: #464c4f;
  font-size: 30px;
}
.introduce {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .introduceImg-box {
    width: 6rem;
    height: 3.6rem;
    margin: 0 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .introduce-img {
    width: 100%;
    height: 100%;
    transition: all 0.3s;
  }
  .introduce-img:hover {
    width: 110%;
    height: 110%;
  }
  .introduce-text {
    width: 6rem;
    margin: 0 0.5rem;
    font-size: 18px;
    line-height: 30px;
    text-align: left;
  }
}
.title {
  margin: 0 auto;
  width: 80%;
  height: 100%;
  .title-logo {
    width: 2rem;
    margin: 14px 1.5rem 14px 4.7rem;
  }
}

.title /deep/.el-carousel__button {
  background-color: #03265c;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue